import { test_demo } from "./Einzeltests/test_demo";
import { test_dsml } from "./Einzeltests/test_dsml";
import { test_chatbots } from "./Einzeltests/test_chatbots";
import { test_mobu21 } from "./Einzeltests/test_mobu21";

// Diese Tests können nach Moodle exportiert werden und in G24 gelöst werden.
const the_test_directory = [test_demo(), test_mobu21()]
export { the_test_directory }
